<div class="message-container">
  <ng-container *ngIf="data.notificationCategory === types.Success">
    <mat-icon class="fa-lg fa-success">check_circle</mat-icon>
  </ng-container>
  <ng-container *ngIf="data.notificationCategory === types.Info">
    <mat-icon class="fa-lg fa-info">info</mat-icon>
  </ng-container>

  <ng-container *ngIf="data.notificationCategory === types.Warning">
    <mat-icon class="fa-lg" color="warn">warning</mat-icon>
  </ng-container>

  <ng-container *ngIf="data.notificationCategory === types.Error">
    <mat-icon class="fa-lg fa-error">error</mat-icon>
  </ng-container>
  <p>
    {{ data.message }}
  </p>
</div>
